import { strl_hit_featured_image } from './hit-featured-image';

function strl_hit_label_names(hit) {
	const labels = [];
	if (Array.isArray(hit.tax_label)) {
		for (let i = 0; i < hit.tax_label.length; i++) {
			const term = hit.tax_label[i];
			if (term && term.name) {
				labels.push(String(term.name));
			}
		}
	}
	if (labels.length === 0 && hit.post_type && strl_vars.cpt_labels[hit.post_type]) {
		labels.push(strl_vars.cpt_labels[hit.post_type]);
	}
	return labels;
}

function strl_hit_excerpt(hit, components) {
	if (hit._snippetResult && hit._snippetResult['settings-group_post-excerpt-content']) {
		return components.Snippet({ attribute: 'settings-group_post-excerpt-content', hit });
	}
	if (hit['settings-group_post-excerpt-content']) {
		return hit['settings-group_post-excerpt-content'];
	}
	if (hit._snippetResult && hit._snippetResult.post_excerpt) {
		return components.Snippet({ attribute: 'post_excerpt', hit });
	}
	if (hit.post_excerpt) {
		return hit.post_excerpt;
	}
	return '';
}

export function defaultCard(hit, html, components) {
	const featuredImage = strl_hit_featured_image(hit);
	const labels = strl_hit_label_names(hit);
	const excerpt = strl_hit_excerpt(hit, components);

	const cardImage = () => {
		if (featuredImage) {
			return html`<div class="relative w-full lg:w-[250px] shrink-0 self-stretch overflow-clip">
				<img
					src="${featuredImage}"
					alt=""
					class="lg:absolute inset-0 size-full object-cover"
					loading="lazy"
				/>
			</div>`;
		}
		return '';
	};

	return html`
		<article
			class="group relative flex max-lg:flex-col overflow-clip rounded-lg bg-white shadow-[-24px_24px_75px_-12px_rgba(18,18,23,0.12)]"
		>
			${cardImage()}

			<div class="grid min-w-0 flex-1 grid-cols-[1fr_auto] items-end gap-8 p-4 lg:p-10">
				<div class="flex min-w-0 flex-col gap-4">
					${labels.length > 0
			? html`<div class="flex flex-wrap gap-2">
								${labels.map(
				(label) => html`<span
										class="bg-sand inline-flex items-center rounded-full px-3 py-2 text-sm leading-none font-medium text-black"
										>${label}</span
									>`
			)}
							</div>`
			: ''}

					<h3 class="h3 font-medium group-hocus:underline">
						${components.Highlight({ attribute: 'post_title', hit })}
					</h3>

					${excerpt ? html`<p class="mb-0 text-base leading-normal font-medium text-black">${excerpt}</p>` : ''}
				</div>

				<a
					href="${hit.permalink}"
					target="_self"
					class="border-black text-black flex size-11 shrink-0 items-center justify-center rounded-full border no-underline"
					aria-label="${strl_vars.read_more_text}"
				>
					<i class="fa-regular fa-arrow-up-right text-base opacity-50" aria-hidden="true"></i>
				</a>
			</div>

			<a href="${hit.permalink}" target="_self" class="overlay-link">
				<span class="sr-only">${strl_vars.read_more_text}</span>
			</a>
		</article>
	`;
}
